import { Modal } from "medere-ui-framework";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import PdfViewer from "../Recipe/Components/PdfViewer";
import SendStudyOrderView from "./NewStudyOrder/SendStudyOrderView";
import { PatientRecordDTO } from "../../interface/interface";
import { ResolvedStudyOrderContext } from "./StudyOrderHistoryView";
import "./StudyOrderPrescriptionModal.scss";

type StudyOrderPrescriptionModalProps = {
  visible: boolean;
  loading: boolean;
  context: ResolvedStudyOrderContext | null;
  error?: string | null;
  onPdfError?: (error: Error) => void;
  expired: boolean;
  onClose: () => void;
  onRepeat: () => void;
  onPatientUpdated: (patient: PatientRecordDTO) => void;
  hideCancelConfirmation?: boolean;
  allowPrimaryEditOnMissingContact?: boolean;
};

export default function StudyOrderPrescriptionModal({
  visible,
  loading,
  context,
  error = null,
  onPdfError,
  expired,
  onClose,
  onRepeat,
  onPatientUpdated,
  hideCancelConfirmation = true,
  allowPrimaryEditOnMissingContact = false,
}: StudyOrderPrescriptionModalProps) {
  return (
    <Modal
      visible={visible}
      setVisible={(visibleValue: boolean) => {
        if (!visibleValue) onClose();
      }}
      header={null}
      closable
      className="study-order-prescription-modal"
      width="w-2xlarge"
    >
      <div className="sopm">
        {loading && (
          <div className="sopm-loadingOverlay" aria-label="Cargando orden">
            <ProgressSpinner style={{ width: "56px", height: "56px" }} strokeWidth="4" />
          </div>
        )}
        <h2 className="sopm-title">Orden de prescripción</h2>

        <div className="sopm-content">
          <div className="sopm-preview">
            {loading ? (
              <div className="sopm-loader">Cargando orden...</div>
            ) : error ? (
              <div className="sopm-error" role="alert">
                <i className="pi pi-exclamation-triangle" aria-hidden="true" />
                <span>{error}</span>
                <Button
                  type="button"
                  label="Cerrar"
                  className="p-button-outlined"
                  onClick={onClose}
                />
              </div>
            ) : context?.pdfEncoded ? (
              <div className="sopm-pdf">
                <PdfViewer fileList={[context.pdfEncoded]} onError={onPdfError} />
              </div>
            ) : (
              <div className="sopm-empty">No se pudo obtener el PDF.</div>
            )}
          </div>

          {!loading && <div className="sopm-divider" />}

          <div className="sopm-actions">
            {context?.patient && context?.professionalId ? (
              <SendStudyOrderView
                patient={context.patient}
                studyOrderData={{ studyOrderId: context.orderId }}
                professionalId={context.professionalId}
                onPatientUpdated={onPatientUpdated}
                showPdf={false}
                initialPdfList={context.pdfEncoded ? [context.pdfEncoded] : []}
                initialPdfFileId={context.pdfFileId}
                onRepeat={onRepeat}
                expiredMode={expired}
                cancelLabel="Salir"
                onCancel={onClose}
                hideCancelConfirmation={hideCancelConfirmation}
                allowPrimaryEditOnMissingContact={allowPrimaryEditOnMissingContact}
                actionHeading="Enviar al paciente"
                helperTitle={expired ? "La orden no se puede utilizar porque se encuentra vencida." : undefined}
              />
            ) : !loading ? (
              <div className="sopm-empty">No se pudo preparar esta orden.</div>
            ) : null}
          </div>
        </div>
      </div>
    </Modal>
  );
}
